import { render, staticRenderFns } from "./PublicMessage.vue?vue&type=template&id=3374d8e1&scoped=true"
import script from "./PublicMessage.vue?vue&type=script&lang=js"
export * from "./PublicMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3374d8e1",
  null
  
)

export default component.exports